import { EditText } from '../../../../../component/ui/edit-text/edit-text';
import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { addNewDocOperations } from '../operations/add-new-doc-operations';
import { ProgramMetadata } from '../../../../../api/types/programs/program-metadata';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { UploadFile } from './upload-file/upload-file';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import { FileUploadFile } from 'primereact/fileupload';
import globalSettingsBranches from '../../../../../stores/global-settings-branches';
import { SettingsBranches } from '../../../../../api/types/settings/branches/settings-branches';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { toast } from 'react-toastify';

interface AddNewDocDialogDataModel {
  userId: number;
  user: UserSummaryType;
  programs?: ProgramMetadata[];
  onHide: () => any;
  updateState: boolean;
}
export const AddNewDocDialog: React.FC<AddNewDocDialogDataModel> = ({
  userId,
  user,
  programs,
  onHide,
  updateState = true,
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedDocTypeId, setSelectedDocTypeId] = useState<number | null>(
    null,
  );
  const [selectedProgram, setSelectedProgram] =
    useState<ProgramMetadata | null>(null);
  const [selectedBranch, setSelectedBranch] = useState<SettingsBranches | null>(
    null,
  );

  const [loading, setLoading] = useState(false);

  const addNewDock = async () => {
    if (!selectedDocTypeId) {
      toast.warn('יש לבחור סוג מסמך');
      return;
    }

    // If a program is selected, use program's branchId and programId
    // If no program but a branch is selected, use branch's id as branchId
    const branchId = selectedProgram?.branchId ?? selectedBranch?.id ?? null;
    const programId = selectedProgram?.id ?? null;

    await addNewDocOperations(
      userId,
      user,
      name,
      description,
      selectedDocTypeId,
      onHide,
      branchId,
      programId,
      false,
      setLoading,
    );
  };

  useEffect(() => {
    console.log(`XXX ${name}`);
  }, [name]);

  const docTypeOptions = globalSettingsStores.docTypes.map((docType) => ({
    label: docType.docTypeName,
    value: docType.id,
  }));

  const isFormValid =
    name.trim().length >= 3 &&
    description.trim().length >= 3 &&
    selectedDocTypeId !== null;

  return (
    <div>
      <EditText
        maxLength={100}
        title={'שם המסמך'}
        onChange={(text: string) => {
          console.log(text);
          setName(text);
        }}
      />
      <EditText maxLength={250} title={'תיאור'} onChange={setDescription} />

      <div>
        <div
          style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px' }}
        >
          סוג מסמך
        </div>
        <Dropdown
          value={selectedDocTypeId}
          onChange={(e: DropdownChangeEvent) => setSelectedDocTypeId(e.value)}
          options={docTypeOptions}
          placeholder="בחר סוג מסמך"
          style={{
            height: '35px',
            alignItems: 'center',
            width: '100%',
            marginBottom: '8px',
          }}
          disabled={loading}
        />
      </div>

      {programs && programs.length > 0 && (
        <div>
          <div
            style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px' }}
          >
            תוכניות
          </div>
          <Dropdown
            value={selectedProgram}
            onChange={(e: DropdownChangeEvent) => setSelectedProgram(e.value)}
            options={programs}
            optionLabel="programName"
            placeholder="בחר תוכנית"
            style={{
              height: '35px',
              alignItems: 'center',
              width: '100%',
              marginBottom: '8px',
            }}
          />
        </div>
      )}

      {(!programs || programs.length === 0) &&
        globalSettingsBranches.branches &&
        globalSettingsBranches.branches.length > 0 && (
          <div>
            <div
              style={{
                fontSize: '14px',
                color: '#4b5563',
                marginBottom: '4px',
              }}
            >
              שלוחות
            </div>
            <Dropdown
              value={selectedBranch}
              onChange={(e: DropdownChangeEvent) => setSelectedBranch(e.value)}
              options={globalSettingsBranches.branches}
              optionLabel="branchName"
              placeholder="בחר שלוחה"
              style={{
                height: '35px',
                alignItems: 'center',
                width: '100%',
                marginBottom: '8px',
              }}
            />
          </div>
        )}
      {/*<UploadFile
        onFileUploaded={(file) => {
          console.log(`File loaded ${!!file}`);
          setUploadedFile(file);
        }}
      />*/}

      <Button
        label={'אישור'}
        onClick={addNewDock}
        loading={loading}
        disabled={!isFormValid || loading}
      />
    </div>
  );
};
